import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const TwentyFourContent = [
  {
    icon: "icon_35",
    title: "E-Commerce",
    desc: ` Retail is the process of selling consumer goods or
    services to customers through multiple channels of
    distribution to earn a profit.`,
    routerPath: "https://www.bigcommerce.com/articles/ecommerce/",
    // arrow: "icon_13",
    // fadeUp: "fade-up",
    // datadelay: "",
  },
  {
    icon: "icon_08",
    title: "Automotive",
    desc: ` The automotive industry comprises a wide range of companies and
    organizations involved in the design, development, manufacturing,
    marketing, and selling of motor vehicles.`,
    // arrow: "icon_13",
    fadeUp: "fade-up",
    datadelay: "100",
    routerPath: "https://www.britannica.com/technology/automotive-industry",
  },
  {
    icon: "icon_09",
    title: "Public Services",
    desc: ` A public service is a service intended to serve all members of a community.`,
    // arrow: "icon_13",
    fadeUp: "fade-up",
    datadelay: "200",
    routerPath: "https://en.wikipedia.org/wiki/Public_service",
  },
  {
    icon: "icon_10",
    title: "Software & Platform",
    desc: `Before you even think about rolling out your website and making your first hire, you’re thinking about the set of tools you’ll use to power your business.`,
    arrow: "icon_13",
    fadeUp: "fade-up",
    datadelay: "100",
    routerPath: "https://blog.hubspot.com/marketing/software-platform",
  },
  {
    icon: "icon_11",
    title: "Hi-Tech Business",
    desc: `High-technology businesses are those engaged in securing growth and revenue from industry sectors characterized by new and rapidly changing technology. `,
    arrow: "icon_13",
    fadeUp: "fade-up",
    datadelay: "200",
    routerPath: "https://www.inc.com/encyclopedia/high-tech-business.html",
  },
  {
    icon: "icon_12",
    title: "Real Estate",
    desc: `Offer future-ready business applications that can learn & adjust with time.`,
    arrow: "icon_13",
    fadeUp: "fade-up",
    datadelay: "300",
    routerPath:
      "https://corporatefinanceinstitute.com/resources/careers/jobs/real-estate/",
  },
];

const FancyFeature24 = () => {
  return (
    <Fragment>
      <div className="row gx-xxl-5">
        {TwentyFourContent.map((val, i) => (
          <div
            key={i}
            className="col-lg-4 col-sm-6 mb-40 xs-mb-30 d-flex"
            data-aos={val.fade}
            data-aos-delay={val.datadelay}
          >
            <div className="block-style-four">
              <div className="icon d-flex align-items-end justify-content-center">
                <img src={`images/icon/${val.icon}.svg`} alt="" />
              </div>
              {/* <h5>{val.title}</h5> */}
              <a onClick={() => window.open(val.routerPath)}>
                <h5>{val.title}</h5>
              </a>
              <p>{val.desc}</p>
              {/* <Link to="/service-details" className="more-btn">
                <img src="images/icon/icon_13.svg" alt="" className="tran3s" />
              </Link> */}
            </div>
            {/* /.block-style-four */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default FancyFeature24;
